
import React, { Component } from 'react';
import moment  from 'moment';
import DatePicker from "react-datepicker";
import { registerLocale } from  "react-datepicker";
import ru from 'date-fns/locale/ru';
import TextField from '@material-ui/core/TextField';
import styled from 'styled-components';
import InputAdornment from '@material-ui/core/InputAdornment';
import ClearIcon from '@material-ui/icons/Clear';
import IconButton from '@material-ui/core/IconButton';

registerLocale('ru', ru);

const Wrapper = styled.div`
  .react-datepicker-wrapper {
    display: block !important;
  }
  
  .react-datepicker-popper {
    z-index: 20;
  }
`;


export class DateWidget extends Component {

  constructor(props) {
    super(props);

    this.inputRef = React.createRef();
  }

  handleChange = (value) => {
    const { onChange } = this.props;
    let stringValue = null;

    if (value) {
      stringValue = moment(value).format('YYYY-MM-DD');
      onChange(value, stringValue);
    }
    else {
      onChange(null, null);
    }
  };

  clearValue = () => {
    const { onChange } = this.props;
    onChange(null, null);
  };

  render() {
    let { value, size, label, disabled, minRangeDate, className, popperPlacement, helperText, error } = this.props;
    let widgetDateValue = null;
    if (value && moment(value).isValid()) {
      widgetDateValue = moment(value).toDate();
    }

    const MaterialInput = React.forwardRef(( props, ref ) => {
      return (
        <TextField
          onClick={props.onClick}
          value={props.value}
          label={label}
          size={size}
          fullWidth={true}
          disabled={disabled}
          helperText={helperText}
          variant="outlined"
          error={error}
          InputProps={{
            endAdornment: (
              ((widgetDateValue && disabled !== true) && (
                <InputAdornment position="end">
                  <IconButton size={'small'} onClick={() => this.clearValue()}>
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ))
            )
          }}
        />
      )
    });

    let rangeProps = {};
    if (minRangeDate) {
      rangeProps = {
        selectsEnd: true,
        startDate: moment(minRangeDate).toDate(),
        endDate: widgetDateValue,
        minDate: moment(minRangeDate).toDate(),
      }
    }

    return (
      <Wrapper className={className}>
        <DatePicker
          selected={widgetDateValue}
          onChange={date => this.handleChange(date)}
          customInput={<MaterialInput />}
          disabled={disabled}
          locale="ru"
          showPopperArrow={false}
          popperPlacement={popperPlacement}
          dateFormat="dd.MM.yyyy"
          {...rangeProps}
        />
      </Wrapper>
    )
  }
}
